/**
 * Cart Drawer Diagnostic Tool
 * This script helps diagnose issues with the cart drawer functionality
 */

document.addEventListener('DOMContentLoaded', function() {
  console.log('Cart Drawer Diagnostic Tool initialized');
  
  // Check if cart drawer exists
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) {
    console.error('Cart drawer element not found on page');
    return;
  }
  
  console.log('Cart drawer element found:', cartDrawer);
  
  // Check for close buttons
  const closeButtons = cartDrawer.querySelectorAll('.drawer__close, .drawer__back-button');
  console.log(`Found ${closeButtons.length} close buttons in cart drawer`);
  
  closeButtons.forEach((button, index) => {
    console.log(`Close button ${index + 1}:`, button);
    
    // Add diagnostic click handler
    button.addEventListener('click', function(event) {
      console.log(`Close button ${index + 1} clicked`, event);
      
      // Check if the close method exists
      if (typeof cartDrawer.close === 'function') {
        console.log('close() method exists on cart-drawer');
      } else {
        console.error('close() method does NOT exist on cart-drawer');
      }
    });
  });
  
  // Check for overlay
  const overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
  if (overlay) {
    console.log('Cart drawer overlay found');
    
    // Add diagnostic click handler
    overlay.addEventListener('click', function(event) {
      console.log('Overlay clicked', event);
    });
  } else {
    console.error('Cart drawer overlay not found');
  }
  
  // Monitor cart drawer visibility
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const isActive = cartDrawer.classList.contains('active');
        console.log(`Cart drawer active state changed: ${isActive ? 'OPEN' : 'CLOSED'}`);
      }
    });
  });
  
  observer.observe(cartDrawer, { attributes: true });
  
  // Add global handler for Escape key
  document.addEventListener('keyup', function(event) {
    if (event.key === 'Escape' && cartDrawer.classList.contains('active')) {
      console.log('Escape key pressed while cart drawer is open');
    }
  });
  
  console.log('Cart drawer diagnostic monitoring active');
});